import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PutScrapFinanceAccountsRequestModel, PutScrapFinanceAccountsResponseModel } from "@/features/accounts/scrap-finance/services/put-accounts-model";

export class PutScrapFinanceAccountsApi {
  /**
   * 銀行口座更新API
   */
  public putScrapFinanceAccounts = async (
    param: PutScrapFinanceAccountsRequestModel
  ): Promise<PutScrapFinanceAccountsResponseModel> => {
    const path = `/api/scrapingaccounts/finances`;
    const res = await ApiClient.instance.put<PutScrapFinanceAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
